import React, { useState, useEffect } from "react";
import styles from "assets/scss/task_management.module.css";
import { Trans } from "react-i18next";
import { Table } from "reactstrap";
import { PayrollClient } from "services";
import { useOrganisationContext, useUserContext} from "hooks";
import { Page } from 'components/common';
import BackButton from 'components/refactoring/BackButton';
import RequestModal from "./RequestModal";
import { NotificationManager } from "react-notifications";

const ReAssignRequests = ({ t }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [reAssignRequestData, setReAssignRequests] = useState([]);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalAction, setModalAction] = useState('');

    const client = PayrollClient();
    const { selectedOrganisation } = useOrganisationContext();
    const user = useUserContext();
    const userPermission = user?.permissions?.includes("hr_task_manager")

    useEffect(() => {
        reassignTaskList();
    }, [selectedOrganisation]);

    const reassignTaskList = async () => {
        try {
            const response = await client.get(`/reassign-task`);
            const data = response.data;
            setReAssignRequests(data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleModalSubmit = async (employees, reason) => {
        try {
            const data = {
                employees: employees,
                manager_reason: reason ,
            };
            if (modalAction === 'approve') {
                await client.post(`/approve-reject-reassign-task/${selectedRequest.id}/approve`, 
                { 
                    data 
                });
                NotificationManager.success("Task approved successfully");
            } else if (modalAction === 'reject') {
                await client.post(`/approve-reject-reassign-task/${selectedRequest.id}/reject`, 
                {
                    data
                });
                NotificationManager.success("Task rejected");
            }
            reassignTaskList();
        } catch (error) {
            console.error(`Error ${modalAction}ing request:`, error);
            NotificationManager.error(`Failed to ${modalAction} request`);
        }
        handleModalClose();
    };

    const filteredReAssignRequests = searchQuery
    ? reAssignRequestData?.filter(request =>
        (
          request?.from_employee.some(employee => employee.full_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
          request?.re_assigned_to.some(employee => employee.full_name.toLowerCase().includes(searchQuery.toLowerCase()))
        )
      )
    : [];
  const dataToRender = (searchQuery && filteredReAssignRequests.length === 0)
    ? []
    : (searchQuery && filteredReAssignRequests.length > 0)
      ? filteredReAssignRequests
      : reAssignRequestData;

    const handleModalOpen = (request, action) => {
        setSelectedRequest(request);
        setModalAction(action);
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedRequest(null);
        setModalAction('');
    };

    return (
        <Page title={t("Re Assign Requests")}>
            <BackButton />
            <div className={styles.groupHeader}>
                <input 
                    className={styles.searchBar}
                    type="search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search..."
                />
            </div>
            <Table size="sm" className="small" style={{ border: '1px solid #e9ecef' }}>
                <thead>
                    <tr>
                        <th className="text-center"><Trans>Task Number</Trans></th>
                        <th className="text-center"><Trans>Date</Trans></th>
                        <th className="text-center"><Trans>From</Trans></th>
                        <th className="text-center"><Trans>To</Trans></th>
                        <th className="text-center"><Trans>Reason</Trans></th>
                        <th className="text-center"><Trans>Action</Trans></th>
                    </tr>
                </thead>
                <tbody>
                    {dataToRender?.map((request, index) => {
                        let id = request.task.id ? request.task.id : "---";
                        let assignedTo = request.re_assigned_to.length > 0 ? request.re_assigned_to[0].full_name : "---";
                        let assignedDate = request.assigned_at ? request.assigned_at : "---";
                        let assignedFrom = request.from_employee.length > 0 ? request.from_employee[0].full_name : "---";
                        let assignedReason = request.assign_reason ? request.assign_reason : "---";

                        return (
                            <tr key={index}>
                                <td className="text-center">{id}</td>
                                <td className="text-center"><Trans>{assignedDate}</Trans></td>
                                <td className="text-center"><Trans>{assignedFrom}</Trans></td>
                                <td className="text-center"><Trans>{assignedTo}</Trans></td>
                                <td className="text-center"><Trans>{assignedReason}</Trans></td>
                                <td className="text-center">
                                    <button 
                                        className={`${styles.editButton}`}
                                        onClick={() => handleModalOpen(request, 'approve')}
                                    >
                                        <Trans>Approve</Trans>
                                    </button>
                                    <button
                                        className={`${styles.deleteButton}`}
                                        onClick={() => handleModalOpen(request, 'reject')}
                                    >
                                        <Trans>Reject</Trans>
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
            {isModalOpen && (
                <RequestModal 
                    isOpen={isModalOpen}
                    action={modalAction}
                    onClose={handleModalClose}
                    onSubmit={handleModalSubmit}
                    selectedOrganisation={selectedOrganisation}
                    userPermission={userPermission}
                    t={t}
                />
            )}
        </Page>
    );
};

export default ReAssignRequests;
